<template>
  <div class="about">
      <Navbar></Navbar>
      <div class="contents">
          <div class="bg"></div>
          <div class="content">
              <div class="middle">
                  <div class="aboutus">
                      <span class="line"></span>
                      <div class="title">加入我们</div>
                      <p>JOIN US</p>
                      <span class="line"></span>
                  </div>
                  <div class="intro">
                      <div class="cn" oncontextmenu="return false" >HI，我们在研发一款很酷的产品，叫做“维码器”！在这，你会有无限的发展空间，如果你热爱创造挑战新事物，不断超越自我的话，请你来加入我们尽情爆发你的小宇宙吧！我们会为你提供晋升、调薪、五险一金、带薪年假、节日活动、逢年过节大红包等福利待遇，还等什么？赶紧把个人简历以及相关作品等联系资料发送至</div>
                      <div class="eg">电子邮箱：<a onpaste="return true" oncopy="return true;" oncontextmenu="return true" >LIKANGZHI@WEIMAQI.COM</a>　联系方式：<a onpaste="return true" oncopy="return true;" oncontextmenu="return true" >020-39992971（李小姐）</a></div>
                  </div>
                  <div class="table">
                            <div class="line-one">
                                <ul>
                                    <li v-for="(item,index) in ones" :key="index">{{item}}</li>
                                </ul>
                            </div>
                            <div class="line-two">
                                  <ul @click="positionClick1(0)">
                                      <li v-for="(item,index) in twos" :key="index">{{item}} <span class="line-stand"></span></li>
                                      <li><div class="imgs"><img  v-show="imgseen" src="./images/down.svg" alt="" ></div>
                                          <div class="imgs1"><img v-show="img2seen" src="./images/up.svg" alt="" ></div>
                                      </li>
                                  </ul> 
                              </div>
                              <div class="show-two" v-show="seentwo" :class="{active:cur==0}">
                                      <div class="show">
                                          <div class="describe">
                                              <h4>部门:</h4>
                                              <p>开发部</p>
                                          </div>
                                          <div class="describe">
                                              <h4>地点:</h4>
                                              <p>广州番禺市桥</p>
                                            <br/>
                                          </div>
                                          <div class="describe">
                                              <h4>职位描述:</h4>
                                              <p>1、负责web端的基础架构设计，框架搭建及核心功能开发</p>
                                              <p>2、负责编写产品api接口,实现产品功能</p>
                                               <br/>
                                          </div>
                                          <div class="ask">
                                              <h4>职位要求:</h4>
                                              <p v-for="(item,index) in asks" :key="index">{{item}}</p>
                                              <br/>
                                          </div>
                                          <div class="experience">
                                              <h4>如有以下工作经验及能力的优先考虑：</h4>
                                              <p>1、拥有或参与过 Github 开源项目</p>
                                              <p>2、具备全栈开发能力</p>
                                              <p>3、熟悉fibjs</p>
                                          </div>
                                      </div>
                                  </div>
                              <div class="line-three">
                                  <ul @click="positionClick2(1)"><li v-for="(item,index) in threes" :key="index">{{item}} <span class="line-stand"></span></li>
                                  <li><div class="imgs"><img v-show="imgseen3" src="./images/down.svg" alt="" ></div>
                                  <div class="imgs1"><img v-show="img3seen" src="./images/up.svg" alt="" ></div>
                                  </li>
                                  </ul>             
                              </div>
                              <div class="show-two" v-show="seenthree" :class="{active:cur==1}">
                                      <div class="show">
                                          <div class="describe">
                                              <h4>部门:</h4>
                                              <p>开发部</p>
                                          </div>
                                          <div class="describe">
                                              <h4>地点:</h4>
                                              <p>广州番禺市桥</p> 
                                              <br/>
                                          </div>
                                          <div class="describe">
                                              <h4>岗位职责：</h4>
                                              <p>1、负责公司产品的前端开发；</p>
                                              <p>2、使用apiclound或者react 开发 app。</p>
                                               <br/>
                                          </div>
                                          <div class="ask">
                                              <h4>岗位要求：</h4>
                                              <!-- <p v-for="(item,index) in asks" :key="index">{{item}}</p> -->
                                              <p>1、大专学历，具备2年以上的前端开发工作经验；</p>
                                              <p>2、有扎实的JavaScript基础；</p>
                                              <p>3、熟练掌握H5，Css3，熟知MVC/MVVM原理，必须具备Vue.Js相关经验；</p>
                                              <p>4、熟悉使用Webpack, Gulp等前端打包、构建工具；</p>
                                              <p>5、熟悉前端后端api交互；</p>
                                              <p>6、有apiclound，react或者其他webapp工作经验优先；</p>
                                              <p>7、此职位必须要有Vue.Js的相关经验。</p>
                                          </div>
                                      </div>
                                  </div>
                              <div class="line-four">
                                   <ul @click="positionClick3(2)"><li v-for="(item,index) in fours" :key="index">{{item}} <span class="line-stand"></span></li>
                                   <li><div class="imgs"><img v-show="imgseen4" src="./images/down.svg" alt="" ></div>
                                   <div class="imgs1"><img v-show="img4seen" src="./images/up.svg" alt="" ></div></li>
                                   </ul>        
                              </div>
                              <div class="show-two" v-show="seenfour" :class="{active:cur==2}">
                                      <div class="show">
                                          <div class="describe">
                                              <h4>部门:</h4>
                                              <p>运营部</p>
                                          </div>
                                          <div class="describe">
                                              <h4>地点:</h4>
                                              <p>广州番禺市桥</p>
                                               <br/>
                                          </div>
                                          <div class="describe">
                                              <h4>工作职责:</h4>
                                              <p>1、根据市场目标、竞争态势、客户需求等，制定网站运营及移动运营的综合运营策略；</p>
                                              <p>2、统筹产品运营、客户运营、内容运营、活动运营等相关运营工作；</p>
                                              <p>3、分析平台数据（流量、点击率、注册投资转化率、留存率等），优化客户画像并统筹客户引流、转化，提升用户粘性；</p>
                                              <p>4、协调各部门，优化内部流程，以提升客户体验度为核心；</p>
                                              <p>5、挖掘忠实客户，通过数据分析，市场调研来分析用户行为，确定用户需求，协助平台的开发与建设。</p>
                                               <br/>
                                          </div>
                                          <div class="ask">
                                              <h4>任职资格:</h4>
                                              <!-- <p v-for="(item,index) in asks" :key="index">{{item}}</p> -->
                                              <p>1、大专以上学历，2年以上运营管理经验，丰富的金融行业背景或互联网行业背景；</p>
                                              <p>2、熟悉P2P业务架构和执行流程，熟悉运营管理结构和流程，了解P2P互联网金融业务的发展现状及趋势；</p>
                                              <p>3、有丰富的网站运营策划和市场推广经验；熟悉网站运营及业务规则，有较丰富的网站策划、项目规划、营销推广经验；</p>
                                              <p>4、有较强的分析规划能力、洞察力、开拓创新能力以及应变能力；</p>
                                              <p>5、有创业精神，目标明确，自我驱动力强，学习能力强，管理多任务的工作经验，能适应压力。</p>
                                          </div>
                                      </div>
                                  </div>
                              <div class="line-five">
                                  <ul @click="positionClick4(3)"><li v-for="(item,index) in fives" :key="index">{{item}} <span class="line-stand"></span></li>
                                  <li><div class="imgs"><img v-show="imgseen5" src="./images/down.svg" alt="" ></div>
                                  <div class="imgs1"><img v-show="img5seen" src="./images/up.svg" alt=""></div></li>
                                  </ul>
                              </div>
                              <div class="show-two" v-show="seenfive" :class="{active:cur==3}">
                                      <div class="show">
                                          <div class="describe">
                                              <h4>部门:</h4>
                                              <p>运营部</p>
                                          </div>
                                          <div class="describe">
                                              <h4>地点:</h4>
                                              <p>广州番禺市桥</p>
                                               <br/>
                                          </div>
                                          <div class="describe">
                                              <h4>工作职责:</h4>
                                              <p>1、了解和熟悉公司业务，开拓自媒体，负责与自媒体的洽谈，促成合作；</p>
                                              <p>2、与自媒体建立持久联系、维护良好关系，探索和熟悉各自媒体属性，满足公司业务需求；</p>
                                              <p>3、独立负责自媒体合作完整流程；</p>
                                              <p>4、负责自媒体信息库的整理；</p>
                                              <p>5、上级领导交办的其他工作。</p>
                                               <br/>
                                          </div>
                                          <div class="ask">
                                              <h4>任职要求：</h4>
                                              <!-- <p v-for="(item,index) in asks" :key="index">{{item}}</p> -->
                                              <p>1、大学专科以上学历，2年以上相关岗位工作经验，专业不限；</p>
                                              <p>2、有商务BD、新媒体运营相关工作经历者优先考虑；</p>
                                              <p>3、普通话标准，沟通能力强，反应速度快，有一定抗压能力；</p>
                                              <p>4、热爱互联网、新媒体，有开拓精神，有团队协作能力及较强的执行力；</p>
                                              <p>5、熟练使用Word、Excel、PPT等办公软件。</p>
                                          </div>
                                      </div>
                                  </div>
                              <div class="line-six">
                                   <ul @click="positionClick5(4)"><li v-for="(item,index) in sixs" :key="index">{{item}} <span class="line-stand"></span></li>
                                   <li><div class="imgs"><img v-show="imgseen6" src="./images/down.svg" alt=""></div>
                                   <div class="imgs1"><img v-show="img6seen" src="./images/up.svg" alt="" ></div></li>
                                   </ul>
                              </div>
                              <div class="show-two" v-show="seensix" :class="{active:cur==4}">
                                      <div class="show">
                                          <div class="describe">
                                              <h4>部门:</h4>
                                              <p>市场部</p>
                                          </div>
                                          <div class="describe">
                                              <h4>地点:</h4>
                                              <p>广州番禺市桥</p>
                                               <br/>
                                          </div>
                                          <div class="describe">
                                              <h4>岗位职责：</h4>
                                              <p>1、按计划完成新客户开发任务并做好老客户维护工作；</p>
                                              <p>2、负责区域内代理商、经销商和客户的业务接洽、咨询及关系维护；</p>
                                              <p>3、配合协助解决产品代理商、经销商及用户反馈的问题，进行市场开拓；</p>
                                              <p>4、负责所属区域的市场推广工作，搜集有效的、有能力的潜在客户资料，且建立完善的客户档案信息；</p>
                                              <p>5、本职位主要是进行移动支付投币器及其硬件销售，线上抓娃娃推广、按摩椅运营场地方寻找等工作。</p>
                                          </div>
                                           <br/>
                                          <div class="ask">
                                              <h4>岗位要求：</h4>
                                              <!-- <p v-for="(item,index) in asks" :key="index">{{item}}</p> -->
                                              <p>1、大专以上学历，市场营销等相关专业；</p>
                                              <p>2、具有1年以上销售工作经验，欢迎优秀的应届毕业生应聘；</p>
                                              <p>3、具备较强的市场分析，营销，推广等能力和良好的人际关系及解决能力；</p>
                                              <p>4、有较强的事业心，具有独担一面的能力；</p>
                                              <p>5、如在自助设备行业(游戏机/娃娃机/售货机)具有一定的客户资源且业绩优秀者会优先考虑。</p>
                                          </div>
                                      </div>
                                  </div>
                              <div class="line-seven">
                                  <ul @click="positionClick6(5)"><li v-for="(item,index) in sevens" :key="index">{{item}} <span class="line-stand"></span></li>
                                  <li><div class="imgs"><img v-show="imgseen7" src="./images/down.svg" alt="" ></div>
                                    <div class="imgs1"><img v-show="img7seen" src="./images/up.svg" alt="" ></div></li>
                                  </ul>
                              </div>
                              <div class="show-two" v-show="seenseven" :class="{active:cur==5}">
                                      <div class="show">
                                          <div class="describe">
                                              <h4>部门:</h4>
                                              <p>客服部</p>
                                          </div>
                                          <div class="describe">
                                              <h4>地点:</h4>
                                              <p>广州番禺市桥</p>
                                               <br/>
                                          </div>
                                          <div class="describe">
                                              <h4>岗位职责：</h4>
                                              <p>1、负责接听4009客户电话，在线解决客户反馈的问题；</p>
                                              <p>2、协助业务员通过QQ、微信等线上交流工具处理客户反馈的售后问题；</p>
                                              <p>3、售后服务发现的问题要及时汇总，并与销售、技术讨论后，找到恰当的解决方案；</p>
                                              <p>4、及时总结反馈客户的建议与意见；</p>
                                              <p>5、完成上级交办的其他事情。</p>
                                               <br/>
                                          </div>
                                          <div class="ask">
                                              <h4>岗位要求:</h4>
                                              <!-- <p v-for="(item,index) in asks" :key="index">{{item}}</p> -->
                                              <p>1、中专以上学历，市场营销等相关专业；</p>
                                              <p>2、具有1年以上客服工作经验，欢迎优秀的应届毕业生应聘；</p>
                                              <p>3、性格开朗，反应敏捷、表达能力强，具有较强的沟通能力及交际技巧；</p>
                                              <p>4、熟悉WORD/EXCEL等办公软件。</p>
                                          </div>
                                      </div>
                                  </div>
                  </div>
                  <div class="photo"></div>
                  <thr></thr>
              </div>
          </div>
           
      </div>
     <foot></foot>
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Foot from '../hardProduct/foot'
import Thr from './thr'
export default {
  name:'about',
  components:{Navbar,Foot,Thr},
  
  data() {
      return{
          cur:'',
          seentwo:false,
          seenthree:false,
          seenfour:false,
          seenfive:false,
          seensix:false,
          seenseven:false,
          imgseen:true,
          imgseen3:true,
          imgseen4:true,
          imgseen5:true,
          imgseen6:true,
          imgseen7:true,
          img2seen:false,
          img3seen:false,
          img4seen:false,
          img5seen:false,
          img6seen:false,
          img7seen:false,
        //   sums:[
        //       {one:'nodejs后台开发工程师',two:'开发部',three:'广州番禺市桥'},
        //       {one:'vue前端工程师',two:'开发部',three:'广州番禺市桥'},
        //       {one:'互联网运营主管/专员',two:'运营部',three:'广州番禺市桥'},
        //       {one:'新媒体运营 （商务BD方向）',two:'运营部',three:'广州番禺市桥'},
        //       {one:'销售代表',two:'市场部',three:'广州番禺市桥'},
        //       {one:'客服专员（售后客服）',two:'客服部',three:'广州番禺市桥'},
        //   ],
          ones:['职位','职位','地点','详情'],
           twos:['nodejs后台开发工程师','开发部','广州番禺市桥'],
           threes:['vue前端工程师','开发部','广州番禺市桥'],
           fours:['互联网运营主管/专员','运营部','广州番禺市桥'],
           fives:['新媒体运营 （商务BD方向）','运营部','广州番禺市桥'],
           sixs:['销售代表','市场部','广州番禺市桥'],
          sevens:['客服专员（售后客服）','客服部','广州番禺市桥'],
          images:[{ img1:require('./images/down.svg'), img2:require('./images/up.svg') }],
          asks:['1、2年以上nodejs开发经验，有大型互联网项目开发经验者优先','2、熟练掌握Javascript，熟悉ES6规范，熟悉Node.js标准库的使用，能完成相应的扩展开发','3、具备Express、thinkjs等框架的使用经验，熟悉HTTP，TCP/IP网络协议','4、熟悉MySQL等关系型数据库应用及优化，熟悉存储引擎及存储过程','5、熟悉 Redis、使用Git管理代码','6、高度的责任心以及良好团队合作精神','7、有高并发Web项目后端开发和前后端分离项目开发经验优先'],
      }
    },
    methods:{
        positionClick1( index ){
            // this.cur = index;
            this.seentwo = !this.seentwo;
            this.imgseen = !this.imgseen;
            this.img2seen = !this.img2seen;
            this.seenthree = false;
            this.seenfour = false;
            this.seenfive = false;
            this.seensix = false;
            this.seenseven = false;
            this.imgseen3 = true;
            this.imgseen4 = true;
            this.imgseen5 = true;
            this.imgseen6 = true;
            this.imgseen7 = true;

             this.img3seen = false;
             this.img4seen = false;
             this.img5seen = false;
             this.img6seen = false;
             this.img7seen = false;
        },
        positionClick2(index){
            // this.cur = index;
            this.seenthree = !this.seenthree;
            this.imgseen3 = !this.imgseen3;
            this.img3seen = !this.img3seen;
            this.seentwo = false;
            this.seenfour = false;
            this.seenfive = false;
            this.seensix = false;
            this.seenseven = false;
            this.imgseen = true;
            this.imgseen4 = true;
            this.imgseen5 = true;
            this.imgseen6 = true;
            this.imgseen7 = true;

            this.img2seen = false;
             this.img4seen = false;
             this.img5seen = false;
             this.img6seen = false;
             this.img7seen = false;
        },
        positionClick3(index){
            // this.cur = index;
            this.seenfour = !this.seenfour;
             this.imgseen4 = !this.imgseen4;
            this.img4seen = !this.img4seen;
            this.seenthree = false;
            this.seentwo = false;
            this.seenfive = false;
            this.seensix = false;
            this.seenseven = false;
            this.imgseen3 = true;
            this.imgseen = true;
            this.imgseen5 = true;
            this.imgseen6 = true;
            this.imgseen7 = true;

            this.img3seen = false;
             this.img2seen = false;
             this.img5seen = false;
             this.img6seen = false;
             this.img7seen = false;
        },
        positionClick4(index){
            // this.cur = index;
            this.seenfive = !this.seenfive;
            this.imgseen5 = !this.imgseen5;
            this.img5seen = !this.img5seen;
            this.seenthree = false;
            this.seenfour = false;
            this.seentwo = false;
            this.seensix = false;
            this.seenseven = false;
            this.imgseen3 = true;
            this.imgseen4 = true;
            this.imgseen = true;
            this.imgseen6 = true;
            this.imgseen7 = true;

            this.img3seen = false;
             this.img4seen = false;
             this.img2seen = false;
             this.img6seen = false;
             this.img7seen = false;
        },
        positionClick5(index){
            // this.cur = index;
            this.seensix = !this.seensix;
            this.imgseen6 = !this.imgseen6;
            this.img6seen = !this.img6seen;
            this.seenthree = false;
            this.seenfour = false;
            this.seenfive = false;
            this.seentwo = false;
            this.seenseven = false;
            this.imgseen3 = true;
            this.imgseen4 = true;
            this.imgseen5 = true;
            this.imgseen = true;
            this.imgseen7 = true;

            this.img3seen = false;
             this.img4seen = false;
             this.img5seen = false;
             this.img2seen = false;
             this.img7seen = false;
        },
        positionClick6(index){
            // this.cur = index;
            this.seenseven = !this.seenseven;
             this.imgseen7 = !this.imgseen7;
            this.img7seen = !this.img7seen;
            this.seenthree = false;
            this.seenfour = false;
            this.seenfive = false;
            this.seensix = false;
            this.seentwo = false;
            this.imgseen3 = true;
            this.imgseen4 = true;
            this.imgseen5 = true;
            this.imgseen6 = true;
            this.imgseen = true;

            this.img3seen = false;
             this.img4seen = false;
             this.img5seen = false;
             this.img6seen = false;
             this.img2seen = false;
        },
    }
}
</script>


<style scoped>
/* .contents .bg .header{
    position: absolute;
    z-index: 0;
} */
.show .describe:nth-child(1),.show .describe:nth-child(2){
    display: none;
}
.contents{
    width: 100%;
}
.contents .bg{
    width: 100%;
    height: 800px;
    background: url(./images/bg3.jpg) no-repeat;
    background-size: cover;
}
.content{
    width:100%;
    height: 100%;   /*为什么写100%没有高度呢*/
    display: flex;
    justify-content: center;
}
.middle{
    width: 1200px;
	/* height: 1100px; */
	background-color: #ffffff;
    margin-top: -200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
}
.aboutus{
    width: 499px;
	height: 133px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 499px 78px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 100px;
}
.aboutus .line{
    width: 24px;
	height: 3px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family: 微软雅黑;
    font-size: 40px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 14px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -18px;
}
.intro{
    width: 800px;
	height: 137px;
    line-height: 36px;
    margin-top: 89px;
}
.intro .cn{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
    color: #999999;
    text-align: justify;
    text-align-last: justify;
}
.intro .eg{
    font-size: 16px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #999999;
    text-align: center;
}
.intro .eg a{
    color: #1a8bff;
}
.photo{
    width:1200px;
    height: 200px;
    background: url(images/xs3.png) no-repeat;
    background-size: cover;
    margin-top: 90px;
}

  .table{
      width: 1160px;
      /* height: 446px; */
      margin-top: 160px;
  }
  .table .imgs img,.table .imgs1 img{
      width: 17px;
	height: 8px;
    cursor: pointer; 
  }
  .table .imgs1{
    position: absolute;
    top: -32px;
    left: 137px;
  }
  .table ul{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .table ul li{
      display: block;
      width: 290px;
      text-align: center;
      font-size: 14px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #999999;
    position: relative;
  }

  .table .line-one{
       width: 1160px;
      height: 54px;
      line-height: 54px;
      background-color: #eaeaea;
      border-top:1px solid #eaeaea;
      border-bottom: 1px solid #eaeaea;
  }
.line-two,.line-three,.line-four,.line-five,.line-six,.line-seven{
	height: 65px;
    line-height: 65px;
    border-bottom: 1px solid #eaeaea;
}
.line-two ul,.line-three ul,.line-four ul,.line-five ul,.line-six ul,.line-seven ul{
    cursor: pointer;
}
.line-stand{
    display: block;
    width: 1px;
    height: 20px;
    background-color: #eaeaea;
    position: absolute;
    top: 23px;
    right: 0px;
}
.show-two{
    padding: 50px 0px 50px 69px;
    transition: all .5s linear;
    /* display: none; */
}
/* .show-two.active{
    display: block;
} */
.show-two.push{
    transform: translateY(-100%);
}
.show{
    /* width: 605px; */
    width: 100%;
    /* height: 406px; */
    height: 100%;
    line-height: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.show h4{
    font-size: 14px;
	font-weight: normal;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #666666;
}
.show p{
    font-size: 14px;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #999999;
}
@media screen and (max-width:1200px){
    .table,.table .line-one{
        width: 900px;
    }
    .table .imgs1{
    position: absolute;
    top: -32px;
    left: 106px;
    }
}

/* 手机 */
@media screen and (max-width:768px){
    .about{
        margin-top: 48px;
    }
    .contents{
        width: 100%;
        height: auto;
    }
    .content{
        height: auto;
    }
    .contents .bg{
    width: 100%;
    height: 205px;
    background: url(./images/phone/BG3.png) no-repeat;
    background-size: 100%;
    }
    .middle{
    width: 90%;
    height: auto;
    margin-top: -70px;
}
.aboutus{
    width: 80%;
	height: 66px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 249px 39px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 35px;
}
.aboutus .line{
    width: 12px;
	height: 1.5px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family:'Times New Roman', Times, serif;
    font-size: 20px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 7px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -9px;
}
.middle .photo{
    width: 100%;
    height: 100px;
    background: url(./images/phone/zs3.png) no-repeat;
    background-size: 100%;
    background-position: center;
    margin-top: 40px;
}
.intro{
    margin-top: 38px;
    line-height: 22px;
    width: 90%;
    height: auto;
}
.intro .cn,.intro .eg{
    font-size: 11px;
	letter-spacing: 0.5px;
	color: #666666;
}
.table{
    margin-top: 35px;
    width: 100%;
}
 .table .line-one,.line-two,.line-three,.line-four,.line-five,.line-six,.line-seven{
     width: 100%;
     height: 44px;
     line-height: 44px;
 }
 .line-two, .line-three,.line-four,.line-five,.line-six,.line-seven{
     border-top: 1px solid #eaeaea;
     border-bottom: 0px;
 }
 .line-seven{
     border-bottom: 1px solid #eaeaea;
 }
 .table .line-one li:nth-child(2), .table .line-one li:nth-child(3),
 .line-two li:nth-child(2), .line-two li:nth-child(3),
 .line-three li:nth-child(2), .line-three li:nth-child(3),
 .line-four li:nth-child(2), .line-four li:nth-child(3),
 .line-five li:nth-child(2), .line-five li:nth-child(3),
 .line-six li:nth-child(2), .line-six li:nth-child(3),
 .line-seven li:nth-child(2), .line-seven li:nth-child(3){
     display: none;
 }
.line-one ul li{
    font-size: 12px;
    letter-spacing: 1px;
	color: #999999;
}
.line-two ul li,.line-three ul li,.line-four ul li,.line-five ul li,.line-six ul li,.line-seven ul li{
font-size: 11px;
    letter-spacing: 1px;
	color: #999999;
}
.table .imgs img, .table .imgs1 img{
    width: 9px;
    height: 5px;
}
.line-one ul li:nth-child(1),
.line-two ul li:nth-child(1), .line-three ul li:nth-child(1), 
.line-four ul li:nth-child(1), .line-five ul li:nth-child(1), 
.line-six ul li:nth-child(1), .line-seven ul li:nth-child(1){
    width: 70%;
}
.line-one ul li:nth-child(4),
.line-two ul li:nth-child(4), .line-three ul li:nth-child(4), 
.line-four ul li:nth-child(4), .line-five ul li:nth-child(4), 
.line-six ul li:nth-child(4), .line-seven ul li:nth-child(4){
    width: 30%;
}
.line-stand{
    top: 14px;
    width: 1px;
    height: 19px;
    line-height: 44px;
}
.table .imgs1{
    position: relative;
    top: 0;
    left: 0;
}
.show .describe:nth-child(1),.show .describe:nth-child(2){
    display: block;
}
.show p{
    font-size: 12px;
}
.show-two{
    padding: 25px 0px 25px 30px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/aboutUs/join.vue